import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// material
import { Box, Card, Button } from '@mui/material';
import ModalPopup from '../../../components/modal-popup/modalpopup';
import RatingReportGrid from './ratingreportgrid';
import MastersService from '../../../services/masters.services';
import DashboardService from '../../../services/dashboard.service';
import AppCache from '../../../services/appcache';
import { handleError } from '../../../auth/utils';
// -------------------------------------------------------------------------------------------------------

RatingReportPopup.propTypes = {
    confirm: PropTypes.func,
};
// -------------------------------------------------------------------------------------------------------

export default function RatingReportPopup({ confirm }) {

    const [columnData, setColumnData] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onClickOk = () => {
        confirm(true)
    };

    const onClickNo = () => {
        confirm(false);
    };

    useEffect(() => {
        setLoading(true);
        // Get the column names of rating report
        setColumnData(MastersService.GetColumns('dealerrating'));
        const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();

        // get dealer rating details
        DashboardService.GetDealerRating(currentLoggedInUser.DistributorCode)
            .then((response) => {
                if (response.status === 200) {
                    setRowData(response.data);
                    setLoading(false);
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error");
                    setLoading(false);
                }
            })
            .catch(_error => {
                    handleError(_error, navigate, "", setLoading);
                });
    }, [navigate])

    return (
        <div>
            <ModalPopup cancel={onClickNo} sx={{ height: 450 }} title='Rating'>
                <Card sx={{ height: 330 }}>
                    <RatingReportGrid columnData={columnData} rowData={rowData} loading={loading} />
                </Card>
                <Box sx={{ position: 'absolute', bottom: 16, right: 16 }}>
                    <Button variant="contained" onClick={onClickOk} value='true' > Ok  </Button>
                </Box>
            </ModalPopup>
        </div >
    )
}